<template>
	<div>
		<h4 class="mb-3">{{ $t('import-results') }}</h4>
		<div class="card mb-3">
			<div class="card-header d-flex align-items-center justify-content-between">
				<span>
					{{ importResults.timetable_name }}
					<span class="badge badge-secondary ml-2">ID {{ importResults.timetable_id }}</span>
				</span>
				<b-button size="sm" variant="primary"
					@click="$router.push(`/timetables/edit/${importResults.timetable_id}`)">
					{{ $t('view-timetable') }} →
				</b-button>
			</div>
			<div class="card-body">
				<p class="text-success mb-1">{{ $t('events-created') }}: <strong>{{ importResults.created_events }}</strong></p>
				<p class="text-secondary mb-3">{{ $t('events-skipped') }}: <strong>{{ importResults.skipped_events }}</strong></p>

				<div v-if="importResults.skipped_rows && importResults.skipped_rows.length" class="mb-3">
					<p class="font-weight-bold mb-1">{{ $t('skipped-rows') }}</p>
					<div class="table-responsive">
						<table class="table table-sm table-bordered">
							<thead class="thead-light">
								<tr>
									<th style="width:4rem">{{ $t('row') }}</th>
									<th>{{ $t('event') }}</th>
									<th>{{ $t('date') }}</th>
									<th>{{ $t('reason') }}</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, i) in importResults.skipped_rows" :key="i"
									:class="row.reason === 'Already exists in timetable' ? 'table-secondary' : 'table-warning'">
									<td class="text-muted">{{ row.line || '—' }}</td>
									<td class="small">{{ row.event || '—' }}</td>
									<td class="small text-muted">{{ row.date || '—' }}</td>
									<td class="small">
										<span v-if="row.reason === 'Already exists in timetable'" class="text-secondary">
											{{ row.reason }}
										</span>
										<span v-else class="text-warning">
											{{ row.reason }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div v-if="importResults.import_warnings && importResults.import_warnings.length" class="mb-3">
					<p class="font-weight-bold mb-1">{{ $t('import-warnings') }}</p>
					<b-table striped hover small responsive :items="importResults.import_warnings"></b-table>
				</div>

				<b-button variant="outline-secondary" class="mt-2" @click="$emit('reset')">
					{{ $t('import-another-timetable') }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		importResults: { type: Object, required: true },
	},
};
</script>
